const rawApiBaseUrl =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.DEV ? 'http://127.0.0.1:5001' : 'https://assetsociety.ngo')
const apiBaseUrl = normalizeBaseUrl(rawApiBaseUrl)

function normalizeBaseUrl(value) {
  return value.trim().replace(/\/+$/, '')
}

function buildApiUrl(path) {
  if (!apiBaseUrl) {
    return path
  }
  return `${apiBaseUrl}${path}`
}

export async function postJson(path, payload) {
  const response = await fetch(buildApiUrl(path), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })

  let result = {}
  try {
    result = await response.json()
  } catch {
    result = {}
  }

  return { response, result }
}
